import { Component, DestroyRef, Input, OnInit, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { loadUnitDetails } from 'src/app/root-store/locums-store/actions/job.actions';
import { jobDetailsLoaded } from '../store/selectors/job-details.selectors';
import { ExternalJobDisplayInputDto } from 'src/app/shared/models/external-job-display-input.dto';
import { EmploymentTypeCode } from 'src/app/shared/models/enums/employment-type-code.enum';
import { FeatureFlag } from 'src/app/shared/models/enums/feature-flag';
import { LDFeatureManager } from 'src/app/shared/services/ld-feature-manager';
import { CandidateSearchComponent } from 'src/app/recruiting/locums-margin-calculator/components/candidate-search/candidate-search.component';
import { MatDialog } from '@angular/material/dialog';
@Component({
    selector: 'nova-locums-recruiter-job-details',
    templateUrl: './locums-recruiter-job-details.component.html',
    styleUrls: ['./locums-recruiter-job-details.component.scss']
})
export class LocumsRecruiterJobDetailsComponent implements OnInit {
    @Input() showBackButton = true;
    @Input() id: number;
    @Input() title: string;
    @Input() displayConfigData: ExternalJobDisplayInputDto;
    @Input() isOnHold?: boolean;

    scrollInProgress = false;
    readonly isLocums1099MarginCalculatorEnabled: Signal<boolean> = toSignal(
        this._ldFeatureManager.isEnabled(FeatureFlag.EnableLocums1099MarginCalculator)
    );

    private readonly selectedJob = this._store.selectSignal(jobDetailsLoaded);
    readonly EmploymentTypeCode = EmploymentTypeCode;
    readonly employmentTypeCode?: EmploymentTypeCode = this.selectedJob()?.job?.employmentTypeCode ?? null;

    constructor(
        private readonly _store: Store,
        private readonly _ldFeatureManager: LDFeatureManager,
        private readonly _destroyRef: DestroyRef,
        private readonly _dialog: MatDialog
    ) {}

    ngOnInit(): void {
        document.querySelector('#sections')?.addEventListener('scrollend', () => this.highlightActiveLinkOnScroll());

        this._store.dispatch(loadUnitDetails({ jobId: this.id }));
    }

    scrollIntoView(id: string) {
        this.scrollInProgress = true;
        document.querySelector(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        this.highlightActiveLink(`${id}Link`);
    }

    highlightActiveLink(id: string) {
        const links = document.querySelector('#sectionLinks')?.getElementsByTagName('a');

        for (const element of Array.from(links)) {
            element.classList.remove('active');
        }

        document.querySelector(id)?.classList.add('active');
    }

    highlightActiveLinkOnScroll() {
        const scrollInProgress = this.scrollInProgress;
        this.scrollInProgress = false;

        if (scrollInProgress) {
            return;
        }

        const sections = document.querySelector('#sections');
        const sectionHeaders = sections.getElementsByTagName('h3');

        if (sections.scrollTop + sections.clientHeight >= sections.scrollHeight) {
            this.highlightActiveLink(`#${sectionHeaders[sectionHeaders.length - 1].id}Link`);
            return;
        }

        const offset = sectionHeaders[0].offsetTop;
        const scrollPosition = sections.scrollTop + offset;
        let id: string;

        for (const element of Array.from(sectionHeaders)) {
            if (element.offsetTop <= scrollPosition) {
                id = `#${element.id}Link`;
            }
        }

        if (id) {
            this.highlightActiveLink(id);
        }
    }

    openCandidateSearchDialog(): void {
        this._dialog.open(CandidateSearchComponent, {
            panelClass: ['candidate-search-dialog'],
            disableClose: true,
            minWidth: 463
        });
    }
}
